module.exports = __webpack_public_path__ + "img/lsuo.8d8ada91.png";